module.exports = __webpack_public_path__ + "static/tetleys-coaches-acquired-by-first-78d65f9153e44117b6b1f18db4f0dbf3.jpg";